<template>
  <el-form class="login-container"
           label-position="left"
           label-width="0px"
           v-loading="loading">
    <h3 class="login_title">系统登录</h3>
    <el-form-item prop="account">
      <el-input type="text"
                v-model="loginForm.username"
                auto-complete="off" placeholder="账号"></el-input>
    </el-form-item>
    <el-form-item prop="checkPass">
      <el-input type="password" v-model="loginForm.password"
                auto-complete="off" placeholder="密码" @keyup.enter.native="submitClick"></el-input>
    </el-form-item>
    <el-checkbox class="login_remember" v-model="checked"
                 label-position="left">记住密码
    </el-checkbox>
    <el-form-item style="width: 100%">
      <el-button type="primary" style="width: 100%" @click="submitClick">登录</el-button>
    </el-form-item>
  </el-form>
</template>
<script>
  export default {
    data() {
      return {
        checked: true,
        loginForm: {
          username: process.env.NODE_ENV === 'development'?'admin':'',
          password: process.env.NODE_ENV === 'development'?'18651582764':''
        },
        loading: false
      }
    },
    methods: {
      submitClick: function () {
        var _this = this;
        if(_this.loginForm.username === '' || _this.loginForm.password === ''){
          _this.$message.error("请输入账号和密码");
          return;
        }
        this.loading = true;
        this.postRequest('/admin/api/sys/login', {
          username: this.loginForm.username,
          password: this.loginForm.password
        }).then(resp => {
          _this.loading = false;
          if (resp && resp.code === 0) {
            var data = resp.data;
            _this.$store.commit('login', data);
            var path = _this.$route.query.redirect;
            _this.$router.replace({path: path === '/' || path === undefined ? '/home' : path});
          }
        });
      }
    }
  }
</script>
<style>
  .login-container {
    border-radius: 15px;
    background-clip: padding-box;
    margin: 180px auto;
    width: 350px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
  }

  .login_title {
    margin: 0px auto 40px auto;
    text-align: center;
    color: #505458;
  }

  .login_remember {
    margin: 0px 0px 35px 0px;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue